import {
  Alert,
  Box,
  Button,
  Grid,
  Paper,
  Snackbar,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import {
  ArrowBack,
  ArrowForward,
  CurrencyRupeeSharp,
  Shortcut,
} from "@mui/icons-material";
import CustomTextField from "../CustomComponents/CustomTextField";
import AccordianContainer from "../CustomComponents/AccordianContainer";
import CustomDataGrid from "../CustomComponents/CustomDataGrid";
import { useState } from "react";
import { useSelector } from "react-redux";
import axios from "axios";

const LoanClosureDetail = (props) => {
  const filterScreen = useSelector((state) => state.loanClosure.filterScreen);

  const [pageSize, setPageSize] = useState(10);
  const columnsData = [
    {
      field: "details",
      headerName: "Memo Description",
      headerAlign: "center",
      flex: 435,
      align: "left",
    },
    {
      field: "receiveable",
      headerName: "Due Amount (₹)",
      headerAlign: "center",
      flex: 190,
      align: "right",
      renderCell: (params) => {
        return <>{parseInt(params.value).toLocaleString("en-IN")}</>;
      },
    },
    {
      field: "received",
      headerName: "Paid Amount  (₹)",
      headerAlign: "center",
      flex: 190,
      align: "right",
      renderCell: (params) => {
        return <>{parseInt(params.value).toLocaleString("en-IN")}</>;
      },
    },
    {
      field: "earlyWaiver",
      headerName: "Waived Amount (₹)",
      headerAlign: "center",
      flex: 190,
      align: "right",
      renderCell: (params) => {
        return <>{parseInt(params.value).toLocaleString("en-IN")}</>;
      },
    },
    {
      field: "osAmount",
      headerName: "Outstanding Amount  (₹)",
      headerAlign: "center",
      flex: 190,
      align: "right",
      renderCell: (params) => {
        var value =
          params.row.receiveable - params.row.received - params.row.earlyWaiver;
        return <>{parseInt(value).toLocaleString("en-IN")}</>;
      },
    },
  ];
  const rows = filterScreen.memoModelList;

  return (
    <>
      <Box sx={{ marginTop: "-1%" }}>
        <Grid container rowSpacing={0} columnSpacing={2}>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              type="text"
              label="Principal (₹)"
              variant="standard"
              placeholder="Principal"
              disabled={true}
              value={
                filterScreen.priciple === ""
                  ? 0
                  : parseInt(filterScreen.priciple).toLocaleString("en-IN")
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              type="text"
              label="Principal OS (₹)"
              variant="standard"
              placeholder="Principal OS"
              disabled={true}
              value={
                filterScreen.pricipleOs === ""
                  ? 0
                  : parseInt(filterScreen.pricipleOs).toLocaleString("en-IN")
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              type="text"
              label="EMI OS (₹)"
              variant="standard"
              placeholder="Enter EMI OS"
              disabled={true}
              value={
                filterScreen.emiOs === ""
                  ? 0
                  : parseInt(filterScreen.emiOs).toLocaleString("en-IN")
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              type="text"
              label="Receipt Amount (₹)"
              variant="standard"
              placeholder="Enter Receipt Amount"
              disabled={true}
              value={
                filterScreen.receiptAmt === ""
                  ? 0
                  : parseInt(filterScreen.receiptAmt).toLocaleString("en-IN")
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              type="text"
              label="Simple Interest (₹)"
              variant="standard"
              placeholder="Enter Simple Interest"
              disabled={true}
              value={
                filterScreen.simpleInterest === ""
                  ? 0
                  : parseInt(filterScreen.simpleInterest).toLocaleString(
                      "en-IN"
                    )
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              type="text"
              label="Prepayment Amount (₹)"
              variant="standard"
              placeholder="Prepayment Amount"
              disabled={true}
              value={
                filterScreen.prePayCharge === ""
                  ? 0
                  : parseInt(filterScreen.prePayCharge).toLocaleString("en-IN")
              }
            />
          </Grid>
          {/* <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              type="text"
              label="Incident Penal (₹)"
              variant="standard"
              placeholder="Enter Incident Penal"
              disabled={true}
              value={
                filterScreen.incidentPenal === ""
                  ? 0
                  : parseInt(filterScreen.incidentPenal).toLocaleString("en-IN")
              }
            />
          </Grid> */}
        </Grid>
      </Box>

      <Box sx={{ marginTop: "12px", marginBottom: "8px" }}>
        <h4>Memo Details:</h4>
        <Grid container rowSpacing={0} columnSpacing={2}>
          <Grid item xs={12} sm={6} md={2.4} lg={2.4} xl={2.4}>
            <label
              style={{
                fontWeight: "bold",
                marginLeft: "8px",
                color: "#2F7DC4",
              }}
            >
              {"Total (₹): "}
              <span style={{ color: "#2F7DC4" }}>
                {filterScreen.memoModelTotal.osTotal === ""
                  ? 0
                  : parseInt(
                      filterScreen.memoModelTotal.osTotal
                    ).toLocaleString("en-IN")}
              </span>
            </label>
          </Grid>
          <Grid item xs={12} sm={6} md={2.4} lg={2.4} xl={2.4}>
            <label
              style={{
                fontWeight: "bold",
                marginLeft: "8px",
                color: "#2F7DC4",
              }}
            >
              {"Due Amount (₹): "}
              <span style={{ color: "#2F7DC4" }}>
                {filterScreen.memoModelTotal.dueTotal === ""
                  ? 0
                  : parseInt(
                      filterScreen.memoModelTotal.dueTotal
                    ).toLocaleString("en-IN")}
              </span>
            </label>
          </Grid>
          <Grid item xs={12} sm={6} md={2.4} lg={2.4} xl={2.4}>
            <label
              style={{
                fontWeight: "bold",
                marginLeft: "8px",
                color: "#2F7DC4",
              }}
            >
              {"Paid Amount (₹): "}
              <span style={{ color: "#2F7DC4" }}>
                {filterScreen.memoModelTotal.paidTotal === ""
                  ? 0
                  : parseInt(
                      filterScreen.memoModelTotal.paidTotal
                    ).toLocaleString("en-IN")}
              </span>
            </label>
          </Grid>
          <Grid item xs={12} sm={6} md={2.4} lg={2.4} xl={2.4}>
            <label
              style={{
                fontWeight: "bold",
                marginLeft: "8px",
                color: "#2F7DC4",
              }}
            >
              {"Waiver (₹): "}
              <span style={{ color: "#2F7DC4" }}>
                {filterScreen.memoModelTotal.waiverTotal === ""
                  ? 0
                  : parseInt(
                      filterScreen.memoModelTotal.waiverTotal
                    ).toLocaleString("en-IN")}
              </span>
            </label>
          </Grid>
          <Grid item xs={12} sm={6} md={2.4} lg={2.4} xl={2.4}>
            <label
              style={{
                fontWeight: "bold",
                marginLeft: "8px",
                color: "#2F7DC4",
              }}
            >
              {"Outstanding (₹): "}
              <span style={{ color: "#2F7DC4" }}>
                {filterScreen.memoModelTotal.osTotal === ""
                  ? 0
                  : parseInt(
                      filterScreen.memoModelTotal.osTotal
                    ).toLocaleString("en-IN")}
              </span>
            </label>
          </Grid>
        </Grid>
      </Box>
      <Box>
        <CustomDataGrid
          noDataMessage="No Data."
          noDataOnFilterMessage="No Data on Applied Filter."
          rows={rows}
          gridHeight={
            rows.length < 4 && rows.length !== 0 ? rows.length * 40 + 130 : 330
          }
          onPageSizeChange={(pageSize) => {
            setPageSize(pageSize);
          }}
          columns={columnsData}
          pageSize={pageSize}
          pageSizeOptions={[4, 8, 12, 16, 20]}
        />
      </Box>
    </>
  );
};
export default LoanClosureDetail;
